<template>
  <p>
    <label :for="name">{{ label }}</label>
    <input
      :type="type || domProps.type || 'text'"
      :name="name"
      :id="name"
      :value="`${name !== 'live_map'? htmlDecode(value) : value}`"
      :required="required"
      :placeholder="placeholder"
      v-on:input="$emit('input', $event.target.value)"
      v-bind="domProps"
      :disabled="disabled"
    />
  </p>
</template>

<script>
export default {
  props: {
    name: String,
    label: String,
    type: String,
    placeholder: String,
    value: [String, Number],
    disabled: Boolean,
    required: {
      type: [Boolean, String],
      default () {
        return false
      }
    },
    domProps: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  methods: {
    htmlDecode (str) {
      const doc = new DOMParser().parseFromString(str, 'text/html')
      return doc.documentElement.textContent.replace(/(<([^>]+)>)/gi, '')
    }
  }
}
</script>
